class FilterClear extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  handleClick = () => {
    this.dispatchEvent(new CustomEvent('filter:clear', {
      bubbles: true
    }));
  };

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }
}

if (!customElements.get('filter-clear')) {
  customElements.define('filter-clear', FilterClear);
}
